import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { Sorting } from "@/core/generated/api/enums/sorting"

@Serializable
export class PagingArgs {
  search: string = ""
  skip: number = 0
  num: number = 25
  sortField?: string = ""
  sortDirection?: string = Sorting.ASC
  filters?: Record<string, unknown>[] = []

  constructor(init?: Partial<PagingArgs>) {
    Object.assign(this, init)
  }
}
